import { useState, useEffect } from "react";

export const useQueryParam = (paramName) => {
  const [paramValue, setParamValue] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    setParamValue(queryParams.get(paramName));
  }, [paramName]);

  return paramValue;
};
